// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1AQtA","footer":"Form_footer__2MPIi"};